// Generated Voice Stories Data for NarratorDetailPage
// Copy this to: fable/Fable-Web/src/data/voiceStories.ts

export interface VoiceStory {
  storyId: string;
  userId: string;
  title: string;
  description: string;
  prompt: string;
  moral: string;
  narrator: string;
  narratorName: string;
  reader: string;
  styleId: string;
  styleName: string;
  storyMode: string;
  storyLanguage: string;
  createdAt: string;
  chapterIds: string[];
  imageUrl: string;
  status: string;
  tokensUsed: number;
}

export const voiceStoriesData: Record<string, VoiceStory[]> = {
  'albus': [
    {
      storyId: '7441ce42-3bd9-4dba-bc3c-7d71a99ed5ad',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Dragon Racing Academy',
      description: 'Young dragon riders compete in the most exciting race through the clouds.',
      prompt: 'Dragon Racing Academy – Young dragon riders compete in the most exciting race through the clouds.',
      moral: 'Integrity',
      narrator: 'albus',
      narratorName: 'Sir Albus',
      reader: 'Adult',
      styleId: 'Pixel',
      styleName: '2D Game',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['7441ce42-3bd9-4dba-bc3c-7d71a99ed5ad'],
      imageUrl: require('../components/images/voicethumbnails/albus1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'b0a32c34-ddcd-46ec-a617-6e4abbcb9edd',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Superhero School',
      description: 'Kids learn to fly, shoot lasers from their eyes, and save the world before lunch.',
      prompt: 'Superhero School – Kids learn to fly, shoot lasers from their eyes, and save the world before lunch.',
      moral: 'Perseverance',
      narrator: 'albus',
      narratorName: 'Sir Albus',
      reader: 'Toddler',
      styleId: 'Minecraft',
      styleName: 'Blockcraft',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.636Z',
      chapterIds: ['b0a32c34-ddcd-46ec-a617-6e4abbcb9edd'],
      imageUrl: require('../components/images/voicethumbnails/albus2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'c85c3054-5850-4332-8b6a-76c025c8a711',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Time-Traveling Treehouse',
      description: 'A magical treehouse takes kids to visit dinosaurs, pirates, and future robots.',
      prompt: 'The Time-Traveling Treehouse – A magical treehouse takes kids to visit dinosaurs, pirates, and future robots.',
      moral: 'Friendship',
      narrator: 'albus',
      narratorName: 'Sir Albus',
      reader: 'Adult',
      styleId: 'Claymation',
      styleName: 'Claymation',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['c85c3054-5850-4332-8b6a-76c025c8a711'],
      imageUrl: require('../components/images/voicethumbnails/albus3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'alloy': [
    {
      storyId: '629295ad-6a4e-4ae7-a9aa-1f20e0fe43d2',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Temple Quest',
      description: 'Explore mystical temples filled with puzzles and golden artifacts.',
      prompt: 'The Mysterious Temple Quest – Explore mystical temples filled with puzzles and golden artifacts.',
      moral: 'Respect',
      narrator: 'alloy',
      narratorName: 'Empress Khali',
      reader: 'Toddler',
      styleId: 'Anime',
      styleName: 'Animation',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['629295ad-6a4e-4ae7-a9aa-1f20e0fe43d2'],
      imageUrl: require('../components/images/voicethumbnails/alloy1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'e5097b34-695d-4b0f-9a8e-169bf645fcfb',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Palace of Wonders',
      description: 'A magical palace where every room grants a different wish.',
      prompt: 'The Palace of Wonders – A magical palace where every room grants a different wish.',
      moral: 'Contentment',
      narrator: 'alloy',
      narratorName: 'Empress Khali',
      reader: 'Teen',
      styleId: 'Wool Knit',
      styleName: 'Cozy Knit',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['e5097b34-695d-4b0f-9a8e-169bf645fcfb'],
      imageUrl: require('../components/images/voicethumbnails/alloy2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'db8b01e7-7025-4ee2-a41a-7c185e28d251',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Yoga Powers Academy',
      description: 'Learn poses that give you superpowers like flying and super strength.',
      prompt: 'Yoga Powers Academy – Learn poses that give you superpowers like flying and super strength.',
      moral: 'Mindfulness',
      narrator: 'alloy',
      narratorName: 'Empress Khali',
      reader: 'Toddler',
      styleId: 'Claymation',
      styleName: 'Claymation',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['db8b01e7-7025-4ee2-a41a-7c185e28d251'],
      imageUrl: require('../components/images/voicethumbnails/alloy3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'amelia': [
    {
      storyId: '73256e2e-b495-4948-ba89-6b6467b9afc4',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Solving the Crown Jewel Mystery',
      description: 'Find the stolen crown jewels before the coronation.',
      prompt: 'Solving the Crown Jewel Mystery – Find the stolen crown jewels before the coronation.',
      moral: 'Truthfulness',
      narrator: 'amelia',
      narratorName: 'Amelia',
      reader: 'Teen',
      styleId: 'Anime',
      styleName: 'Animation',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['73256e2e-b495-4948-ba89-6b6467b9afc4'],
      imageUrl: require('../components/images/voicethumbnails/amelia1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '03c56157-0ca3-425d-9813-b8a298722cc1',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Tea Party Time Travel',
      description: 'Every cup of tea transports you to a different time period.',
      prompt: 'Tea Party Time Travel – Every cup of tea transports you to a different time period.',
      moral: 'Patience',
      narrator: 'amelia',
      narratorName: 'Amelia',
      reader: 'Teen',
      styleId: 'Pixel',
      styleName: '2D Game',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['03c56157-0ca3-425d-9813-b8a298722cc1'],
      imageUrl: require('../components/images/voicethumbnails/amelia2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '0ba9e17d-cbc0-49ab-9b1f-2130c7fa5f1f',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Royal Academy of Manners',
      description: 'Learn etiquette that has magical effects on the world.',
      prompt: 'The Royal Academy of Manners – Learn etiquette that has magical effects on the world.',
      moral: 'Respect',
      narrator: 'amelia',
      narratorName: 'Amelia',
      reader: 'Adult',
      styleId: 'Comic Book',
      styleName: 'Comic Book',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['0ba9e17d-cbc0-49ab-9b1f-2130c7fa5f1f'],
      imageUrl: require('../components/images/voicethumbnails/amelia3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'anna': [
    {
      storyId: 'fca6a810-7ea1-4ecb-8807-d454572c8680',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Ice Skating Champions',
      description: 'Perform magical routines that make the ice glow and sparkle.',
      prompt: 'Ice Skating Champions – Perform magical routines that make the ice glow and sparkle.',
      moral: 'Perseverance',
      narrator: 'anna',
      narratorName: 'Princess Anna',
      reader: 'Teen',
      styleId: 'Pixel',
      styleName: '2D Game',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['fca6a810-7ea1-4ecb-8807-d454572c8680'],
      imageUrl: require('../components/images/voicethumbnails/anna1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '93b1561f-0c76-4443-adf9-6fa2c21b5ac8',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Northern Lights Mystery',
      description: 'Discover why the aurora borealis is sending secret messages.',
      prompt: 'The Northern Lights Mystery – Discover why the aurora borealis is sending secret messages.',
      moral: 'Truthfulness',
      narrator: 'anna',
      narratorName: 'Princess Anna',
      reader: 'Adult',
      styleId: '3D Cartoon',
      styleName: '3D Cartoon',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['93b1561f-0c76-4443-adf9-6fa2c21b5ac8'],
      imageUrl: require('../components/images/voicethumbnails/anna2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '6bf7a56f-3de4-4142-ac50-518ebfeed183',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Winter Magic Academy',
      description: 'Control ice, snow, and create beautiful frozen sculptures that come alive.',
      prompt: 'Winter Magic Academy – Control ice, snow, and create beautiful frozen sculptures that come alive.',
      moral: 'Sharing',
      narrator: 'anna',
      narratorName: 'Princess Anna',
      reader: 'Adult',
      styleId: '3D Cartoon',
      styleName: '3D Cartoon',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['6bf7a56f-3de4-4142-ac50-518ebfeed183'],
      imageUrl: require('../components/images/voicethumbnails/anna3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'arthur': [
    {
      storyId: '8af1fbbe-77dc-4eb3-8224-4eb580490f9d',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Knights of the Cardboard Castle',
      description: 'Kids build forts that become real castles with real quests.',
      prompt: 'Knights of the Cardboard Castle – Kids build forts that become real castles with real quests.',
      moral: 'Integrity',
      narrator: 'arthur',
      narratorName: 'King Arthur',
      reader: 'Teen',
      styleId: 'Water Color',
      styleName: 'Watercolor',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['8af1fbbe-77dc-4eb3-8224-4eb580490f9d'],
      imageUrl: require('../components/images/voicethumbnails/arthur1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '9990ce25-38b4-47b1-8074-844e44237783',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Invisible Spy Academy',
      description: 'Learn to become invisible and stop the bad guys without being seen.',
      prompt: 'The Invisible Spy Academy – Learn to become invisible and stop the bad guys without being seen.',
      moral: 'Mindfulness',
      narrator: 'arthur',
      narratorName: 'King Arthur',
      reader: 'Adult',
      styleId: 'Claymation',
      styleName: 'Claymation',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['9990ce25-38b4-47b1-8074-844e44237783'],
      imageUrl: require('../components/images/voicethumbnails/arthur2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '7d14b748-655a-430f-99d2-e97284d50866',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Treasure Island Adventure',
      description: 'A map leads to an island filled with puzzles, traps, and golden treasure.',
      prompt: 'Treasure Island Adventure – A map leads to an island filled with puzzles, traps, and golden treasure.',
      moral: 'Perseverance',
      narrator: 'arthur',
      narratorName: 'King Arthur',
      reader: 'Adult',
      styleId: 'Claymation',
      styleName: 'Claymation',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['7d14b748-655a-430f-99d2-e97284d50866'],
      imageUrl: require('../components/images/voicethumbnails/arthur3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'ash': [
    {
      storyId: '1a15e47e-18a7-45c0-bd57-937d72ab2a60',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Basketball with Superpowers',
      description: 'A street basketball game where everyone has a different superpower.',
      prompt: 'Basketball with Superpowers – A street basketball game where everyone has a different superpower.',
      moral: 'Fairness',
      narrator: 'ash',
      narratorName: 'Ash',
      reader: 'Teen',
      styleId: 'Comic Book',
      styleName: 'Comic Book',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['1a15e47e-18a7-45c0-bd57-937d72ab2a60'],
      imageUrl: require('../components/images/voicethumbnails/ash1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '171119bf-bfd8-4d6a-bf5c-802ee86be234',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Beat Box Battle Royale',
      description: 'Music creates real magic effects in an epic competition.',
      prompt: 'Beat Box Battle Royale – Music creates real magic effects in an epic competition.',
      moral: 'Respect',
      narrator: 'ash',
      narratorName: 'Ash',
      reader: 'Toddler',
      styleId: 'Comic Book',
      styleName: 'Comic Book',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['171119bf-bfd8-4d6a-bf5c-802ee86be234'],
      imageUrl: require('../components/images/voicethumbnails/ash2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'ae78e30f-8caa-438d-828f-f5928fc810ec',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Skateboard That Flies',
      description: 'A magic skateboard takes you on adventures through the city and beyond.',
      prompt: 'The Skateboard That Flies – A magic skateboard takes you on adventures through the city and beyond.',
      moral: 'Example',
      narrator: 'ash',
      narratorName: 'Ash',
      reader: 'Toddler',
      styleId: '3D Cartoon',
      styleName: '3D Cartoon',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['ae78e30f-8caa-438d-828f-f5928fc810ec'],
      imageUrl: require('../components/images/voicethumbnails/ash3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'ballad': [
    {
      storyId: '3d72f29d-9671-4832-93d9-6182de606fd1',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Comedy Club for Kids',
      description: 'Learn to make people laugh with jokes, impressions, and silly stunts.',
      prompt: 'Comedy Club for Kids – Learn to make people laugh with jokes, impressions, and silly stunts.',
      moral: 'Kindness',
      narrator: 'ballad',
      narratorName: 'Lucky McGuire',
      reader: 'Teen',
      styleId: 'Minecraft',
      styleName: 'Blockcraft',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['3d72f29d-9671-4832-93d9-6182de606fd1'],
      imageUrl: require('../components/images/voicethumbnails/ballad1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '950ae501-e88a-4c08-9801-20473cf4fe53',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Rock Star Academy',
      description: 'Form a band, learn instruments, and play concerts with magical effects.',
      prompt: 'Rock Star Academy – Form a band, learn instruments, and play concerts with magical effects.',
      moral: 'Friendship',
      narrator: 'ballad',
      narratorName: 'Lucky McGuire',
      reader: 'Toddler',
      styleId: '3D Cartoon',
      styleName: '3D Cartoon',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['950ae501-e88a-4c08-9801-20473cf4fe53'],
      imageUrl: require('../components/images/voicethumbnails/ballad2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'a3e688b2-79a7-4e7a-813a-3099bc64691b',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Prank Wars Championship',
      description: 'The funniest, most creative pranks win the golden whoopee cushion.',
      prompt: 'The Prank Wars Championship – The funniest, most creative pranks win the golden whoopee cushion.',
      moral: 'Fairness',
      narrator: 'ballad',
      narratorName: 'Lucky McGuire',
      reader: 'Adult',
      styleId: 'Claymation',
      styleName: 'Claymation',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['a3e688b2-79a7-4e7a-813a-3099bc64691b'],
      imageUrl: require('../components/images/voicethumbnails/ballad3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'beth': [
    {
      storyId: '54fe3ded-0a6d-4195-ba94-0ee321a07f5c',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Grandmother\'s Secret Potion Shop',
      description: 'Every potion does something wonderfully weird and magical.',
      prompt: 'Grandmother\'s Secret Potion Shop – Every potion does something wonderfully weird and magical.',
      moral: 'Kindness',
      narrator: 'beth',
      narratorName: 'Aunt Beth',
      reader: 'Adult',
      styleId: 'Minecraft',
      styleName: 'Blockcraft',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['54fe3ded-0a6d-4195-ba94-0ee321a07f5c'],
      imageUrl: require('../components/images/voicethumbnails/beth1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'b36401bf-8376-4f63-86ed-2f10f158299b',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Library of Living Books',
      description: 'Books come alive and take you inside their stories.',
      prompt: 'The Library of Living Books – Books come alive and take you inside their stories.',
      moral: 'Respect',
      narrator: 'beth',
      narratorName: 'Aunt Beth',
      reader: 'Adult',
      styleId: 'Wool Knit',
      styleName: 'Cozy Knit',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['b36401bf-8376-4f63-86ed-2f10f158299b'],
      imageUrl: require('../components/images/voicethumbnails/beth2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '433d0e65-7458-429d-a897-c12fa638a62c',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Mystery of the Talking Teapot',
      description: 'A magical teapot knows everyone\'s secrets and fortunes.',
      prompt: 'The Mystery of the Talking Teapot – A magical teapot knows everyone\'s secrets and fortunes.',
      moral: 'Truthfulness',
      narrator: 'beth',
      narratorName: 'Aunt Beth',
      reader: 'Toddler',
      styleId: 'Photo Realism',
      styleName: 'Photo Realism',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['433d0e65-7458-429d-a897-c12fa638a62c'],
      imageUrl: require('../components/images/voicethumbnails/beth3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'captain': [
    {
      storyId: 'c0813396-2d08-41b1-80c6-a2b66ad41541',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Ghost Ship Mystery',
      description: 'A haunted pirate ship appears only at midnight with a mystery to solve.',
      prompt: 'Ghost Ship Mystery – A haunted pirate ship appears only at midnight with a mystery to solve.',
      moral: 'Truthfulness',
      narrator: 'captain',
      narratorName: 'Captain Flint',
      reader: 'Teen',
      styleId: 'Wool Knit',
      styleName: 'Cozy Knit',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['c0813396-2d08-41b1-80c6-a2b66ad41541'],
      imageUrl: require('../components/images/voicethumbnails/captain1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '159cdc41-7472-429f-9586-094ee8b15edc',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Island Survival Challenge',
      description: 'Stranded kids use pirate skills to build shelter and signal for rescue.',
      prompt: 'Island Survival Challenge – Stranded kids use pirate skills to build shelter and signal for rescue.',
      moral: 'Perseverance',
      narrator: 'captain',
      narratorName: 'Captain Flint',
      reader: 'Toddler',
      styleId: 'Pixel',
      styleName: '2D Game',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['159cdc41-7472-429f-9586-094ee8b15edc'],
      imageUrl: require('../components/images/voicethumbnails/captain2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '5a83193f-3e37-4f3d-afd7-85809c560798',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Pirate Treasure Hunt',
      description: 'Sail the seven seas, battle sea monsters, and find legendary treasure.',
      prompt: 'Pirate Treasure Hunt – Sail the seven seas, battle sea monsters, and find legendary treasure.',
      moral: 'Reliability',
      narrator: 'captain',
      narratorName: 'Captain Flint',
      reader: 'Teen',
      styleId: 'Anime',
      styleName: 'Animation',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['5a83193f-3e37-4f3d-afd7-85809c560798'],
      imageUrl: require('../components/images/voicethumbnails/captain3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'coral': [
    {
      storyId: '036acbe9-3fe4-4912-bb1f-9301fae9c15b',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Beach Volleyball with Powers',
      description: 'Every player has a superpower making the game extraordinary.',
      prompt: 'Beach Volleyball with Powers – Every player has a superpower making the game extraordinary.',
      moral: 'Respect',
      narrator: 'coral',
      narratorName: 'Finn',
      reader: 'Toddler',
      styleId: 'Water Color',
      styleName: 'Watercolor',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['036acbe9-3fe4-4912-bb1f-9301fae9c15b'],
      imageUrl: require('../components/images/voicethumbnails/coral1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '9b23e5f0-438b-4487-9866-81c3b1b9916e',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Surfing on Sound Waves',
      description: 'Ride music through the air in the coolest competition ever.',
      prompt: 'Surfing on Sound Waves – Ride music through the air in the coolest competition ever.',
      moral: 'Friendship',
      narrator: 'coral',
      narratorName: 'Finn',
      reader: 'Toddler',
      styleId: 'Minecraft',
      styleName: 'Blockcraft',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['9b23e5f0-438b-4487-9866-81c3b1b9916e'],
      imageUrl: require('../components/images/voicethumbnails/coral2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '17f54d8e-83b4-4328-9096-ca4048794dde',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Dolphin Racing League',
      description: 'Race alongside dolphins through underwater obstacle courses.',
      prompt: 'The Dolphin Racing League – Race alongside dolphins through underwater obstacle courses.',
      moral: 'Fairness',
      narrator: 'coral',
      narratorName: 'Finn',
      reader: 'Toddler',
      styleId: 'Anime',
      styleName: 'Animation',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['17f54d8e-83b4-4328-9096-ca4048794dde'],
      imageUrl: require('../components/images/voicethumbnails/coral3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'echo': [
    {
      storyId: 'd08226af-2a4b-4d66-8c81-02b4ec9e429f',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Lightning Speed Training',
      description: 'Learn to run faster than lightning and stop time itself.',
      prompt: 'Lightning Speed Training – Learn to run faster than lightning and stop time itself.',
      moral: 'Perseverance',
      narrator: 'echo',
      narratorName: 'Dexter Dynamite',
      reader: 'Adult',
      styleId: 'Water Color',
      styleName: 'Watercolor',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['d08226af-2a4b-4d66-8c81-02b4ec9e429f'],
      imageUrl: require('../components/images/voicethumbnails/echo1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'c9b30587-d79b-4fb6-95ec-0bf3652ebfc9',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Super Science Lab',
      description: 'Experiments that create super abilities and amazing inventions.',
      prompt: 'Super Science Lab – Experiments that create super abilities and amazing inventions.',
      moral: 'Example',
      narrator: 'echo',
      narratorName: 'Dexter Dynamite',
      reader: 'Adult',
      styleId: 'Water Color',
      styleName: 'Watercolor',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['c9b30587-d79b-4fb6-95ec-0bf3652ebfc9'],
      imageUrl: require('../components/images/voicethumbnails/echo2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'eedd0dba-e1db-4a57-baee-ac70f17b142a',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Robot Building Contest',
      description: 'Build your own robot friend and teach it to help people.',
      prompt: 'The Robot Building Contest – Build your own robot friend and teach it to help people.',
      moral: 'Kindness',
      narrator: 'echo',
      narratorName: 'Dexter Dynamite',
      reader: 'Toddler',
      styleId: 'Minecraft',
      styleName: 'Blockcraft',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['eedd0dba-e1db-4a57-baee-ac70f17b142a'],
      imageUrl: require('../components/images/voicethumbnails/echo3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'fable': [
    {
      storyId: 'bb5a6f5e-2710-46ae-87c4-657f96a9d283',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Knights of the Round Table',
      description: 'Young knights train to be brave, noble, and protect the kingdom.',
      prompt: 'Knights of the Round Table – Young knights train to be brave, noble, and protect the kingdom.',
      moral: 'Integrity',
      narrator: 'fable',
      narratorName: 'Lucian',
      reader: 'Toddler',
      styleId: 'Anime',
      styleName: 'Animation',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['bb5a6f5e-2710-46ae-87c4-657f96a9d283'],
      imageUrl: require('../components/images/voicethumbnails/fable1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '4b1e748d-37f3-4c4e-91fd-465400fe5c96',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Dragon Tamer\'s Challenge',
      description: 'Learn to befriend and ride the fiercest dragons in the land.',
      prompt: 'The Dragon Tamer\'s Challenge – Learn to befriend and ride the fiercest dragons in the land.',
      moral: 'Patience',
      narrator: 'fable',
      narratorName: 'Lucian',
      reader: 'Toddler',
      styleId: 'Wool Knit',
      styleName: 'Cozy Knit',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['4b1e748d-37f3-4c4e-91fd-465400fe5c96'],
      imageUrl: require('../components/images/voicethumbnails/fable2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'd6d9c0e2-9fd8-482f-bd04-5bfd48e6dd1a',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Storyteller\'s Quest',
      description: 'Every story you tell becomes real and you must live through it.',
      prompt: 'The Storyteller\'s Quest – Every story you tell becomes real and you must live through it.',
      moral: 'Truthfulness',
      narrator: 'fable',
      narratorName: 'Lucian',
      reader: 'Toddler',
      styleId: 'Wool Knit',
      styleName: 'Cozy Knit',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['d6d9c0e2-9fd8-482f-bd04-5bfd48e6dd1a'],
      imageUrl: require('../components/images/voicethumbnails/fable3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'fiona': [
    {
      storyId: '77e3392e-3afd-4de5-aff8-899020439146',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Ocean Adventure School',
      description: 'Dive deep, swim with dolphins, and explore sunken ships.',
      prompt: 'Ocean Adventure School – Dive deep, swim with dolphins, and explore sunken ships.',
      moral: 'Friendship',
      narrator: 'fiona',
      narratorName: 'Fiona',
      reader: 'Adult',
      styleId: 'Minecraft',
      styleName: 'Blockcraft',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['77e3392e-3afd-4de5-aff8-899020439146'],
      imageUrl: require('../components/images/voicethumbnails/fiona1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '419bc61e-b946-4325-9087-f9bf431c1bd4',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Pirate Queen\'s Treasure Fleet',
      description: 'Lead a crew of adventurers to find the legendary lost treasure.',
      prompt: 'Pirate Queen\'s Treasure Fleet – Lead a crew of adventurers to find the legendary lost treasure.',
      moral: 'Reliability',
      narrator: 'fiona',
      narratorName: 'Fiona',
      reader: 'Teen',
      styleId: 'Anime',
      styleName: 'Animation',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['419bc61e-b946-4325-9087-f9bf431c1bd4'],
      imageUrl: require('../components/images/voicethumbnails/fiona2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'f7f69254-95d8-4e1e-8f0b-7e4c3a2d0c22',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Sea Monster Rescue',
      description: 'Save friendly sea monsters from hunters and help them hide.',
      prompt: 'The Sea Monster Rescue – Save friendly sea monsters from hunters and help them hide.',
      moral: 'Kindness',
      narrator: 'fiona',
      narratorName: 'Fiona',
      reader: 'Teen',
      styleId: 'Water Color',
      styleName: 'Watercolor',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['f7f69254-95d8-4e1e-8f0b-7e4c3a2d0c22'],
      imageUrl: require('../components/images/voicethumbnails/fiona3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'jane': [
    {
      storyId: 'f644617b-31f4-4d30-a146-4f61327d8821',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Jungle Explorer Academy',
      description: 'Swing on vines, discover lost cities, and befriend exotic animals.',
      prompt: 'Jungle Explorer Academy – Swing on vines, discover lost cities, and befriend exotic animals.',
      moral: 'Friendship',
      narrator: 'jane',
      narratorName: 'Nimble',
      reader: 'Toddler',
      styleId: 'Anime',
      styleName: 'Animation',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['f644617b-31f4-4d30-a146-4f61327d8821'],
      imageUrl: require('../components/images/voicethumbnails/jane1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'c5373ef6-7e14-4f1e-a80b-a603138a92d1',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Mountain Climbing Champions',
      description: 'Scale the tallest peaks and plant your flag at the summit.',
      prompt: 'Mountain Climbing Champions – Scale the tallest peaks and plant your flag at the summit.',
      moral: 'Perseverance',
      narrator: 'jane',
      narratorName: 'Nimble',
      reader: 'Toddler',
      styleId: 'Anime',
      styleName: 'Animation',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['c5373ef6-7e14-4f1e-a80b-a603138a92d1'],
      imageUrl: require('../components/images/voicethumbnails/jane2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '30cb8523-6419-43ac-a8e3-8dc1ade913a0',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Volcano Rescue Mission',
      description: 'A team races against time to save a village from an erupting volcano.',
      prompt: 'The Volcano Rescue Mission – A team races against time to save a village from an erupting volcano.',
      moral: 'Reliability',
      narrator: 'jane',
      narratorName: 'Nimble',
      reader: 'Adult',
      styleId: 'Photo Realism',
      styleName: 'Photo Realism',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['30cb8523-6419-43ac-a8e3-8dc1ade913a0'],
      imageUrl: require('../components/images/voicethumbnails/jane3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'juggernaut': [
    {
      storyId: 'becd0b96-88c8-4112-8eec-40af60be5e0d',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Monster Truck Mayhem',
      description: 'Giant trucks with minds of their own race through impossible courses.',
      prompt: 'Monster Truck Mayhem – Giant trucks with minds of their own race through impossible courses.',
      moral: 'Reliability',
      narrator: 'juggernaut',
      narratorName: 'Lord Ragnar',
      reader: 'Teen',
      styleId: 'Pixel',
      styleName: '2D Game',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['becd0b96-88c8-4112-8eec-40af60be5e0d'],
      imageUrl: require('../components/images/voicethumbnails/juggernaut1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'edd48a72-b817-4363-8df5-088eda08c891',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Strongest Kid in the World',
      description: 'A competition to find who can lift the most ridiculous things.',
      prompt: 'The Strongest Kid in the World – A competition to find who can lift the most ridiculous things.',
      moral: 'Example',
      narrator: 'juggernaut',
      narratorName: 'Lord Ragnar',
      reader: 'Adult',
      styleId: 'Minecraft',
      styleName: 'Blockcraft',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['edd48a72-b817-4363-8df5-088eda08c891'],
      imageUrl: require('../components/images/voicethumbnails/juggernaut2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '3cb6d04e-3a13-41ab-9226-5295f4a5184f',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Viking Warriors in Training',
      description: 'Young Vikings learn to sail, battle, and explore new lands.',
      prompt: 'Viking Warriors in Training – Young Vikings learn to sail, battle, and explore new lands.',
      moral: 'Perseverance',
      narrator: 'juggernaut',
      narratorName: 'Lord Ragnar',
      reader: 'Toddler',
      styleId: '3D Cartoon',
      styleName: '3D Cartoon',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['3cb6d04e-3a13-41ab-9226-5295f4a5184f'],
      imageUrl: require('../components/images/voicethumbnails/juggernaut3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'juni': [
    {
      storyId: '7fabddad-caa9-40f1-8600-5a0078342e09',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Shrinking Adventure',
      description: 'Accidentally shrink to ant-size and explore the backyard jungle.',
      prompt: 'Shrinking Adventure – Accidentally shrink to ant-size and explore the backyard jungle.',
      moral: 'Perseverance',
      narrator: 'juni',
      narratorName: 'Juni',
      reader: 'Toddler',
      styleId: 'Minecraft',
      styleName: 'Blockcraft',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['7fabddad-caa9-40f1-8600-5a0078342e09'],
      imageUrl: require('../components/images/voicethumbnails/juni1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '795cee4c-7cb9-4682-84da-8b4946badd3f',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Invention Competition',
      description: 'Kids build crazy inventions that actually work with hilarious results.',
      prompt: 'The Invention Competition – Kids build crazy inventions that actually work with hilarious results.',
      moral: 'Example',
      narrator: 'juni',
      narratorName: 'Juni',
      reader: 'Adult',
      styleId: '3D Cartoon',
      styleName: '3D Cartoon',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['795cee4c-7cb9-4682-84da-8b4946badd3f'],
      imageUrl: require('../components/images/voicethumbnails/juni2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'cf96248c-1ee5-411f-a008-1c662de53757',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Laughing Potion Mystery',
      description: 'Someone made a potion that makes everyone laugh non-stop.',
      prompt: 'The Laughing Potion Mystery – Someone made a potion that makes everyone laugh non-stop.',
      moral: 'Kindness',
      narrator: 'juni',
      narratorName: 'Juni',
      reader: 'Adult',
      styleId: 'Wool Knit',
      styleName: 'Cozy Knit',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['cf96248c-1ee5-411f-a008-1c662de53757'],
      imageUrl: require('../components/images/voicethumbnails/juni3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'nova': [
    {
      storyId: '9df943bf-ac43-4dff-8951-2dd6c6e6c9ea',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Animal Whisperer Academy',
      description: 'Students learn to talk to animals and go on wild rescue missions.',
      prompt: 'Animal Whisperer Academy – Students learn to talk to animals and go on wild rescue missions.',
      moral: 'Kindness',
      narrator: 'nova',
      narratorName: 'Penny Snow',
      reader: 'Adult',
      styleId: 'Minecraft',
      styleName: 'Blockcraft',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['9df943bf-ac43-4dff-8951-2dd6c6e6c9ea'],
      imageUrl: require('../components/images/voicethumbnails/nova1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'f6790f65-e3d9-4bb8-a50d-ca95e9b316eb',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Magic Paintbrush School',
      description: 'Every painting you create comes to life and becomes your friend.',
      prompt: 'Magic Paintbrush School – Every painting you create comes to life and becomes your friend.',
      moral: 'Sharing',
      narrator: 'nova',
      narratorName: 'Penny Snow',
      reader: 'Toddler',
      styleId: 'Wool Knit',
      styleName: 'Cozy Knit',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['f6790f65-e3d9-4bb8-a50d-ca95e9b316eb'],
      imageUrl: require('../components/images/voicethumbnails/nova2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'a9367bae-3a7e-479e-9a54-3e75f86d6883',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Teleporting Twins',
      description: 'Brother and sister can teleport anywhere instantly and have amazing adventures.',
      prompt: 'The Teleporting Twins – Brother and sister can teleport anywhere instantly and have amazing adventures.',
      moral: 'Friendship',
      narrator: 'nova',
      narratorName: 'Penny Snow',
      reader: 'Adult',
      styleId: 'Wool Knit',
      styleName: 'Cozy Knit',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['a9367bae-3a7e-479e-9a54-3e75f86d6883'],
      imageUrl: require('../components/images/voicethumbnails/nova3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'onyx': [
    {
      storyId: 'db83364e-15d1-4c79-8900-9222cca7bb83',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Desert Treasure Trail',
      description: 'Follow a mysterious map through cacti and canyons to find gold.',
      prompt: 'Desert Treasure Trail – Follow a mysterious map through cacti and canyons to find gold.',
      moral: 'Perseverance',
      narrator: 'onyx',
      narratorName: 'Boots',
      reader: 'Toddler',
      styleId: 'Minecraft',
      styleName: 'Blockcraft',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['db83364e-15d1-4c79-8900-9222cca7bb83'],
      imageUrl: require('../components/images/voicethumbnails/onyx1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '89d4f26f-8e3a-47cd-8268-2f56b5a425d2',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Ranch of Magical Creatures',
      description: 'Take care of unicorns, phoenixes, and baby dragons.',
      prompt: 'The Ranch of Magical Creatures – Take care of unicorns, phoenixes, and baby dragons.',
      moral: 'Kindness',
      narrator: 'onyx',
      narratorName: 'Boots',
      reader: 'Toddler',
      styleId: 'Claymation',
      styleName: 'Claymation',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['89d4f26f-8e3a-47cd-8268-2f56b5a425d2'],
      imageUrl: require('../components/images/voicethumbnails/onyx2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'a6bccac9-561e-4435-a6bc-1303dbd167f9',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Wild West Rodeo Heroes',
      description: 'Ride wild horses, lasso tornadoes, and save the frontier town.',
      prompt: 'Wild West Rodeo Heroes – Ride wild horses, lasso tornadoes, and save the frontier town.',
      moral: 'Reliability',
      narrator: 'onyx',
      narratorName: 'Boots',
      reader: 'Adult',
      styleId: 'Water Color',
      styleName: 'Watercolor',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.637Z',
      chapterIds: ['a6bccac9-561e-4435-a6bc-1303dbd167f9'],
      imageUrl: require('../components/images/voicethumbnails/onyx3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'optimus': [
    {
      storyId: '8ccb35f4-b339-4c88-a745-ca4fd199e0cd',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Robot Battle Championship',
      description: 'Build and pilot giant robots to save Earth from alien invaders.',
      prompt: 'Robot Battle Championship – Build and pilot giant robots to save Earth from alien invaders.',
      moral: 'Example',
      narrator: 'optimus',
      narratorName: 'Optimus',
      reader: 'Toddler',
      styleId: 'Water Color',
      styleName: 'Watercolor',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['8ccb35f4-b339-4c88-a745-ca4fd199e0cd'],
      imageUrl: require('../components/images/voicethumbnails/optimus1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '1b425fc3-95d9-4200-bac5-adf0cea595a7',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Space Explorer Academy',
      description: 'Kids train to explore new planets and meet alien friends.',
      prompt: 'Space Explorer Academy – Kids train to explore new planets and meet alien friends.',
      moral: 'Respect',
      narrator: 'optimus',
      narratorName: 'Optimus',
      reader: 'Teen',
      styleId: 'Comic Book',
      styleName: 'Comic Book',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['1b425fc3-95d9-4200-bac5-adf0cea595a7'],
      imageUrl: require('../components/images/voicethumbnails/optimus2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '388a0291-5443-471d-b891-d904399f1f90',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Super Speed Squad',
      description: 'A team of speedsters race around the world stopping crimes.',
      prompt: 'The Super Speed Squad – A team of speedsters race around the world stopping crimes.',
      moral: 'Reliability',
      narrator: 'optimus',
      narratorName: 'Optimus',
      reader: 'Toddler',
      styleId: 'Claymation',
      styleName: 'Claymation',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['388a0291-5443-471d-b891-d904399f1f90'],
      imageUrl: require('../components/images/voicethumbnails/optimus3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'orin': [
    {
      storyId: '55c8ed8a-b794-4e8f-97d8-ca222d43bfd4',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Dark Magic Academy',
      description: 'Learn mysterious spells that control shadows, mist, and moonlight.',
      prompt: 'Dark Magic Academy – Learn mysterious spells that control shadows, mist, and moonlight.',
      moral: 'Truthfulness',
      narrator: 'orin',
      narratorName: 'Orin Stormvale',
      reader: 'Adult',
      styleId: 'Water Color',
      styleName: 'Watercolor',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['55c8ed8a-b794-4e8f-97d8-ca222d43bfd4'],
      imageUrl: require('../components/images/voicethumbnails/orin1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '73bd8f4a-7e02-4690-9f6e-840bddc2251d',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Haunted Mansion Challenge',
      description: 'Spend one night in the spookiest mansion to win a prize.',
      prompt: 'The Haunted Mansion Challenge – Spend one night in the spookiest mansion to win a prize.',
      moral: 'Perseverance',
      narrator: 'orin',
      narratorName: 'Orin Stormvale',
      reader: 'Toddler',
      styleId: 'Photo Realism',
      styleName: 'Photo Realism',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['73bd8f4a-7e02-4690-9f6e-840bddc2251d'],
      imageUrl: require('../components/images/voicethumbnails/orin2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '6b0d6d82-899c-45b9-bc84-5d24a77eb69b',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Vampire Academy',
      description: 'Young vampires learn to use their powers for good instead of evil.',
      prompt: 'Vampire Academy – Young vampires learn to use their powers for good instead of evil.',
      moral: 'Forgiveness',
      narrator: 'orin',
      narratorName: 'Orin Stormvale',
      reader: 'Toddler',
      styleId: '3D Cartoon',
      styleName: '3D Cartoon',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['6b0d6d82-899c-45b9-bc84-5d24a77eb69b'],
      imageUrl: require('../components/images/voicethumbnails/orin3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'percy': [
    {
      storyId: 'ec68c7cf-9f80-42b7-8103-adf339847d07',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Ancient Dragon\'s Riddle',
      description: 'Solve the dragon\'s puzzle to receive wisdom and treasure.',
      prompt: 'The Ancient Dragon\'s Riddle – Solve the dragon\'s puzzle to receive wisdom and treasure.',
      moral: 'Truthfulness',
      narrator: 'percy',
      narratorName: 'Master Percy',
      reader: 'Teen',
      styleId: 'Claymation',
      styleName: 'Claymation',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['ec68c7cf-9f80-42b7-8103-adf339847d07'],
      imageUrl: require('../components/images/voicethumbnails/percy1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'e7e28f76-2b96-4112-96e5-2044c1fb23a0',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Enchanted Forest Quest',
      description: 'Navigate a magical forest where every tree has a secret.',
      prompt: 'The Enchanted Forest Quest – Navigate a magical forest where every tree has a secret.',
      moral: 'Respect',
      narrator: 'percy',
      narratorName: 'Master Percy',
      reader: 'Teen',
      styleId: 'Anime',
      styleName: 'Animation',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['e7e28f76-2b96-4112-96e5-2044c1fb23a0'],
      imageUrl: require('../components/images/voicethumbnails/percy2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '9d658131-a5ed-417b-b31c-90e0d1422d5a',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Wizard School for Young Mages',
      description: 'Learn spells, potions, and how to turn your teacher into a frog.',
      prompt: 'Wizard School for Young Mages – Learn spells, potions, and how to turn your teacher into a frog.',
      moral: 'Mindfulness',
      narrator: 'percy',
      narratorName: 'Master Percy',
      reader: 'Toddler',
      styleId: 'Minecraft',
      styleName: 'Blockcraft',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['9d658131-a5ed-417b-b31c-90e0d1422d5a'],
      imageUrl: require('../components/images/voicethumbnails/percy3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'polly': [
    {
      storyId: '264026fa-abc1-4ebe-b9bd-9c9c38778ead',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Dollhouse Come to Life',
      description: 'A magical dollhouse becomes a real world to explore.',
      prompt: 'Dollhouse Come to Life – A magical dollhouse becomes a real world to explore.',
      moral: 'Friendship',
      narrator: 'polly',
      narratorName: 'Dot',
      reader: 'Teen',
      styleId: 'Water Color',
      styleName: 'Watercolor',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['264026fa-abc1-4ebe-b9bd-9c9c38778ead'],
      imageUrl: require('../components/images/voicethumbnails/polly1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'd5c46846-873f-4ffb-9cd3-6fb8d90c733e',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Miniature Magic Show',
      description: 'Perform amazing tricks with tiny props and huge results.',
      prompt: 'The Miniature Magic Show – Perform amazing tricks with tiny props and huge results.',
      moral: 'Example',
      narrator: 'polly',
      narratorName: 'Dot',
      reader: 'Toddler',
      styleId: 'Anime',
      styleName: 'Animation',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['d5c46846-873f-4ffb-9cd3-6fb8d90c733e'],
      imageUrl: require('../components/images/voicethumbnails/polly2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '265082e5-2337-4cc5-8972-5338a7b1bae0',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Tiny Fairy Detective Agency',
      description: 'Solve big mysteries even though you\'re only three inches tall.',
      prompt: 'Tiny Fairy Detective Agency – Solve big mysteries even though you\'re only three inches tall.',
      moral: 'Truthfulness',
      narrator: 'polly',
      narratorName: 'Dot',
      reader: 'Toddler',
      styleId: 'Minecraft',
      styleName: 'Blockcraft',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['265082e5-2337-4cc5-8972-5338a7b1bae0'],
      imageUrl: require('../components/images/voicethumbnails/polly3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'queen': [
    {
      storyId: '24d697f8-c3d7-4ffc-928b-c5e1ffc10d60',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Fashion School for Superheroes',
      description: 'Design costumes that give heroes their powers.',
      prompt: 'Fashion School for Superheroes – Design costumes that give heroes their powers.',
      moral: 'Example',
      narrator: 'queen',
      narratorName: 'Queen Bee',
      reader: 'Toddler',
      styleId: 'Pixel',
      styleName: '2D Game',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['24d697f8-c3d7-4ffc-928b-c5e1ffc10d60'],
      imageUrl: require('../components/images/voicethumbnails/queen1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '09866d2c-f1d3-4fd2-9031-362d980ae297',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Princess Warrior Academy',
      description: 'Princesses train in combat, magic, and diplomacy to protect their kingdoms.',
      prompt: 'Princess Warrior Academy – Princesses train in combat, magic, and diplomacy to protect their kingdoms.',
      moral: 'Integrity',
      narrator: 'queen',
      narratorName: 'Queen Bee',
      reader: 'Teen',
      styleId: 'Photo Realism',
      styleName: 'Photo Realism',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['09866d2c-f1d3-4fd2-9031-362d980ae297'],
      imageUrl: require('../components/images/voicethumbnails/queen2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'e116ac56-541c-4510-bec2-777164284b92',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Singing Contest of Destiny',
      description: 'Whoever wins gets three magical wishes.',
      prompt: 'The Singing Contest of Destiny – Whoever wins gets three magical wishes.',
      moral: 'Contentment',
      narrator: 'queen',
      narratorName: 'Queen Bee',
      reader: 'Adult',
      styleId: '3D Cartoon',
      styleName: '3D Cartoon',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['e116ac56-541c-4510-bec2-777164284b92'],
      imageUrl: require('../components/images/voicethumbnails/queen3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'quinn': [
    {
      storyId: '0cb3ff6a-4f2b-4d5d-8cb3-89b8e8ca048f',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Sarcasm Superpower',
      description: 'Learn that quick wit and humor can save the day.',
      prompt: 'The Sarcasm Superpower – Learn that quick wit and humor can save the day.',
      moral: 'Kindness',
      narrator: 'quinn',
      narratorName: 'Harvey Quinn',
      reader: 'Teen',
      styleId: 'Anime',
      styleName: 'Animation',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['0cb3ff6a-4f2b-4d5d-8cb3-89b8e8ca048f'],
      imageUrl: require('../components/images/voicethumbnails/quinn1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'e5829f01-80c2-4fbe-bc17-edf4b1c1221f',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Unlikely Heroes Unite',
      description: 'The most unlikely group of kids become the greatest heroes ever.',
      prompt: 'Unlikely Heroes Unite – The most unlikely group of kids become the greatest heroes ever.',
      moral: 'Friendship',
      narrator: 'quinn',
      narratorName: 'Harvey Quinn',
      reader: 'Teen',
      styleId: 'Photo Realism',
      styleName: 'Photo Realism',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['e5829f01-80c2-4fbe-bc17-edf4b1c1221f'],
      imageUrl: require('../components/images/voicethumbnails/quinn2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'c30c61c5-ec8b-4d15-b249-7b925035a3df',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Whatever Academy',
      description: 'A school where nothing goes as planned but everything turns out hilarious.',
      prompt: 'Whatever Academy – A school where nothing goes as planned but everything turns out hilarious.',
      moral: 'Contentment',
      narrator: 'quinn',
      narratorName: 'Harvey Quinn',
      reader: 'Toddler',
      styleId: 'Pixel',
      styleName: '2D Game',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['c30c61c5-ec8b-4d15-b249-7b925035a3df'],
      imageUrl: require('../components/images/voicethumbnails/quinn3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'ruby': [
    {
      storyId: '0e17987d-51e7-4a51-ae93-1a937bf0567c',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Gymnastics with Superpowers',
      description: 'Flip, tumble, and soar through the air with enhanced abilities.',
      prompt: 'Gymnastics with Superpowers – Flip, tumble, and soar through the air with enhanced abilities.',
      moral: 'Perseverance',
      narrator: 'ruby',
      narratorName: 'Ruby',
      reader: 'Adult',
      styleId: 'Anime',
      styleName: 'Animation',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['0e17987d-51e7-4a51-ae93-1a937bf0567c'],
      imageUrl: require('../components/images/voicethumbnails/ruby1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '901ef350-36a8-45f0-bbeb-78f59fd1f943',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Parkour Heroes',
      description: 'Jump across rooftops and save the city with incredible acrobatics.',
      prompt: 'Parkour Heroes – Jump across rooftops and save the city with incredible acrobatics.',
      moral: 'Reliability',
      narrator: 'ruby',
      narratorName: 'Ruby',
      reader: 'Teen',
      styleId: 'Claymation',
      styleName: 'Claymation',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['901ef350-36a8-45f0-bbeb-78f59fd1f943'],
      imageUrl: require('../components/images/voicethumbnails/ruby2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'c591a50c-2159-4a9d-be83-f378ed6b19e6',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Crystal Cavern Adventure',
      description: 'Explore caves filled with glowing crystals that grant wishes.',
      prompt: 'The Crystal Cavern Adventure – Explore caves filled with glowing crystals that grant wishes.',
      moral: 'Sharing',
      narrator: 'ruby',
      narratorName: 'Ruby',
      reader: 'Toddler',
      styleId: 'Comic Book',
      styleName: 'Comic Book',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['c591a50c-2159-4a9d-be83-f378ed6b19e6'],
      imageUrl: require('../components/images/voicethumbnails/ruby3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'sage': [
    {
      storyId: 'e51a8c0e-f824-423c-87c0-f87936145cbc',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Ninja School for Beginners',
      description: 'Learn stealth, backflips, and how to disappear in a cloud of smoke.',
      prompt: 'Ninja School for Beginners – Learn stealth, backflips, and how to disappear in a cloud of smoke.',
      moral: 'Mindfulness',
      narrator: 'sage',
      narratorName: 'Sage',
      reader: 'Teen',
      styleId: 'Comic Book',
      styleName: 'Comic Book',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['e51a8c0e-f824-423c-87c0-f87936145cbc'],
      imageUrl: require('../components/images/voicethumbnails/sage1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'e43290c4-a513-40f3-9758-5c33f41f0021',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Enchanted Video Game',
      description: 'Players get sucked into a video game and must beat all levels to escape.',
      prompt: 'The Enchanted Video Game – Players get sucked into a video game and must beat all levels to escape.',
      moral: 'Perseverance',
      narrator: 'sage',
      narratorName: 'Sage',
      reader: 'Teen',
      styleId: 'Photo Realism',
      styleName: 'Photo Realism',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['e43290c4-a513-40f3-9758-5c33f41f0021'],
      imageUrl: require('../components/images/voicethumbnails/sage2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '1c67e31a-c8f0-4fa8-a995-bab268485164',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Mystery of the Missing Magic',
      description: 'Someone is stealing all the magic in the kingdom, and only you can solve it.',
      prompt: 'The Mystery of the Missing Magic – Someone is stealing all the magic in the kingdom, and only you can solve it.',
      moral: 'Truthfulness',
      narrator: 'sage',
      narratorName: 'Sage',
      reader: 'Teen',
      styleId: 'Wool Knit',
      styleName: 'Cozy Knit',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['1c67e31a-c8f0-4fa8-a995-bab268485164'],
      imageUrl: require('../components/images/voicethumbnails/sage3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'shimmer': [
    {
      storyId: '719c2a0d-2107-48f0-8352-70ff5645cca2',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Fairy Flight School',
      description: 'Tiny fairies learn loop-de-loops, speed flying, and magical dust tricks.',
      prompt: 'Fairy Flight School – Tiny fairies learn loop-de-loops, speed flying, and magical dust tricks.',
      moral: 'Perseverance',
      narrator: 'shimmer',
      narratorName: 'Cherry Twinkel',
      reader: 'Teen',
      styleId: '3D Cartoon',
      styleName: '3D Cartoon',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['719c2a0d-2107-48f0-8352-70ff5645cca2'],
      imageUrl: require('../components/images/voicethumbnails/shimmer1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '9dec88bb-23d7-4c00-8bc5-f9ebc910edc1',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Rainbow Racing',
      description: 'Slide down rainbows in the fastest, most colorful race ever.',
      prompt: 'Rainbow Racing – Slide down rainbows in the fastest, most colorful race ever.',
      moral: 'Friendship',
      narrator: 'shimmer',
      narratorName: 'Cherry Twinkel',
      reader: 'Teen',
      styleId: 'Pixel',
      styleName: '2D Game',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['9dec88bb-23d7-4c00-8bc5-f9ebc910edc1'],
      imageUrl: require('../components/images/voicethumbnails/shimmer2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'bb41e69b-f37f-4b6e-add2-f68f43f5c53b',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Glitter Bomb Mystery',
      description: 'Someone is covering the town in magical glitter and you must find out who.',
      prompt: 'The Glitter Bomb Mystery – Someone is covering the town in magical glitter and you must find out who.',
      moral: 'Truthfulness',
      narrator: 'shimmer',
      narratorName: 'Cherry Twinkel',
      reader: 'Toddler',
      styleId: 'Claymation',
      styleName: 'Claymation',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['bb41e69b-f37f-4b6e-add2-f68f43f5c53b'],
      imageUrl: require('../components/images/voicethumbnails/shimmer3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'verse': [
    {
      storyId: 'dc163a93-c2a5-48a4-b3ac-330dbecf2222',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Gravity Control School',
      description: 'Learn to walk on walls, float in air, and flip gravity upside down.',
      prompt: 'Gravity Control School – Learn to walk on walls, float in air, and flip gravity upside down.',
      moral: 'Mindfulness',
      narrator: 'verse',
      narratorName: 'Atlas',
      reader: 'Adult',
      styleId: '3D Cartoon',
      styleName: '3D Cartoon',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['dc163a93-c2a5-48a4-b3ac-330dbecf2222'],
      imageUrl: require('../components/images/voicethumbnails/verse1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'da005285-37a9-4ea0-83cf-73a94dd00402',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Mind Reading Academy',
      description: 'Develop telepathy and learn to communicate without words.',
      prompt: 'Mind Reading Academy – Develop telepathy and learn to communicate without words.',
      moral: 'Respect',
      narrator: 'verse',
      narratorName: 'Atlas',
      reader: 'Toddler',
      styleId: 'Photo Realism',
      styleName: 'Photo Realism',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['da005285-37a9-4ea0-83cf-73a94dd00402'],
      imageUrl: require('../components/images/voicethumbnails/verse2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '488a9107-c0f6-4cf8-873d-175903d39734',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Shadow Warriors',
      description: 'Control your shadow to fight evil and protect the innocent.',
      prompt: 'The Shadow Warriors – Control your shadow to fight evil and protect the innocent.',
      moral: 'Integrity',
      narrator: 'verse',
      narratorName: 'Atlas',
      reader: 'Teen',
      styleId: 'Pixel',
      styleName: '2D Game',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['488a9107-c0f6-4cf8-873d-175903d39734'],
      imageUrl: require('../components/images/voicethumbnails/verse3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'walker': [
    {
      storyId: '8cc69e9f-c942-49f9-ab21-c259b63a075b',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Flying Lessons',
      description: 'A school where everyone learns to soar through the sky like birds.',
      prompt: 'Flying Lessons – A school where everyone learns to soar through the sky like birds.',
      moral: 'Patience',
      narrator: 'walker',
      narratorName: 'Ms. Walker',
      reader: 'Toddler',
      styleId: 'Minecraft',
      styleName: 'Blockcraft',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['8cc69e9f-c942-49f9-ab21-c259b63a075b'],
      imageUrl: require('../components/images/voicethumbnails/walker1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '1eefce56-db2e-4f61-85a6-0b68362f6934',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Mermaid Mystery Detectives',
      description: 'Underwater sleuths solve the mystery of the stolen pearls.',
      prompt: 'Mermaid Mystery Detectives – Underwater sleuths solve the mystery of the stolen pearls.',
      moral: 'Fairness',
      narrator: 'walker',
      narratorName: 'Ms. Walker',
      reader: 'Teen',
      styleId: 'Wool Knit',
      styleName: 'Cozy Knit',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['1eefce56-db2e-4f61-85a6-0b68362f6934'],
      imageUrl: require('../components/images/voicethumbnails/walker2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'da3e87a0-e230-4b93-b912-37069213e3ae',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Magical Bakery',
      description: 'Every cookie and cupcake grants a different superpower for one hour.',
      prompt: 'The Magical Bakery – Every cookie and cupcake grants a different superpower for one hour.',
      moral: 'Kindness',
      narrator: 'walker',
      narratorName: 'Ms. Walker',
      reader: 'Toddler',
      styleId: 'Minecraft',
      styleName: 'Blockcraft',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['da3e87a0-e230-4b93-b912-37069213e3ae'],
      imageUrl: require('../components/images/voicethumbnails/walker3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ],
  'william': [
    {
      storyId: 'b3995e6d-3219-495b-9d90-6c6bae1a6e10',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Detective Academy for Kids',
      description: 'Solve mysteries using clues, disguises, and super smart thinking.',
      prompt: 'Detective Academy for Kids – Solve mysteries using clues, disguises, and super smart thinking.',
      moral: 'Truthfulness',
      narrator: 'william',
      narratorName: 'Detective Gadget',
      reader: 'Adult',
      styleId: 'Photo Realism',
      styleName: 'Photo Realism',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['b3995e6d-3219-495b-9d90-6c6bae1a6e10'],
      imageUrl: require('../components/images/voicethumbnails/william1.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: 'b92f9402-6bff-459b-8611-f4be939e3a05',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'Secret Agent Training',
      description: 'Learn gadgets, codes, and how to save the world in style.',
      prompt: 'Secret Agent Training – Learn gadgets, codes, and how to save the world in style.',
      moral: 'Reliability',
      narrator: 'william',
      narratorName: 'Detective Gadget',
      reader: 'Toddler',
      styleId: 'Claymation',
      styleName: 'Claymation',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['b92f9402-6bff-459b-8611-f4be939e3a05'],
      imageUrl: require('../components/images/voicethumbnails/william2.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    },
    {
      storyId: '40afe3b8-abd4-4218-bfbe-36d93222ba90',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: 'The Case of the Vanishing Homework',
      description: 'Homework is disappearing and you must find the culprit.',
      prompt: 'The Case of the Vanishing Homework – Homework is disappearing and you must find the culprit.',
      moral: 'Integrity',
      narrator: 'william',
      narratorName: 'Detective Gadget',
      reader: 'Toddler',
      styleId: 'Water Color',
      styleName: 'Watercolor',
      storyMode: 'Regular',
      storyLanguage: 'en',
      createdAt: '2025-10-03T05:08:13.638Z',
      chapterIds: ['40afe3b8-abd4-4218-bfbe-36d93222ba90'],
      imageUrl: require('../components/images/voicethumbnails/william3.jpeg'),
      status: 'scheduled',
      tokensUsed: 1,
    }
  ]
};

export default voiceStoriesData;
